// extracted by mini-css-extract-plugin
export default {"tripNameCell":"TripPage_tripNameCell__1i73g"};